import React from 'react';
import whiteGraphIcon from '../../static/icons/white-graph-icon.svg';
import blackGraphIcon from '../../static/icons/black-graph-icon.svg';
import whiteTableIcon from '../../static/icons/white-table-icon.svg';
import blackTableIcon from '../../static/icons/black-table-icon.svg';

export function RubricViewToggle({ mode, onTable, onGraph }) {
  const isTable = mode === 'table';
  const isGraph = mode === 'graph';

  return (
    <div className="ci-rubric-view-toggle">
      <button
        className={`ci-view-btn ${isTable ? 'active' : ''}`}
        type="button"
        onClick={onTable}
      >
        <img
          src={isTable ? whiteTableIcon : blackTableIcon}
          className="ci-grid-list-icon"
          alt=""
        />
        Table view
      </button>
      <button
        className={`ci-view-btn ${isGraph ? 'active' : ''}`}
        type="button"
        onClick={onGraph}
      >
        <img
          src={isGraph ? whiteGraphIcon : blackGraphIcon}
          className="ci-grid-list-icon"
          alt=""
        />
        Graph View
      </button>
    </div>
  );
}
